import React from 'react'
import WidgetComponent from './widgetComponent'
import { Link } from 'react-router-dom'
import context from '@/context'
import WidgetContent from '@/components/reporting/widgetContent'
import Resx from '@/components/Resx'

class ReportSubmissionsWidget extends WidgetComponent {
  headerButtons () { return <Link to='/report-submission-groups'><Resx name='Common.More' /></Link> }
  widgetIcon () { return 'report' }
  widgetTitleKey () { return 'Reporting.WidgetTitle' }
  dataSource () { return context.api.reportSubmissionGroupService.getDashboardItems(this._prepareDataSourceRequest(this.props.widgetItem)) }
  renderContent (data) { return <WidgetContent data={data.data} /> }
}

export {
  ReportSubmissionsWidget
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/reportSubmissions.js